/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyEuroOff = createReactComponent("outline", "currency-euro-off", "IconCurrencyEuroOff", [["path", { "d": "M17.2 7c-1.977 -2.26 -4.954 -2.602 -7.234 -1.04m-1.913 2.079c-1.604 2.72 -1.374 6.469 .69 8.894c2.292 2.691 6 2.758 8.356 .18", "key": "svg-0" }], ["path", { "d": "M10 10h-5m0 4h8", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconCurrencyEuroOff as default };
//# sourceMappingURL=IconCurrencyEuroOff.mjs.map
